import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { useLockBodyScroll } from '../lib/use-lock-body-scroll';

/** Generic dialog chrome (backdrop, header with icon/title/subtitle, scrollable
 * body) shared by the training "Termin hinzufügen" and "Serien verwalten"
 * dialogs — a plain overlay `<div>`, not a native `<dialog>`, matching the
 * hand-rolled pattern the rest of the app already uses (RosterModal etc.). */
export function Modal({
  title,
  subtitle,
  icon,
  onClose,
  children,
  maxWidthClassName = 'max-w-lg',
}: {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  maxWidthClassName?: string;
}) {
  useLockBodyScroll();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        className={`flex max-h-[90vh] w-full ${maxWidthClassName} flex-col overflow-hidden rounded-2xl bg-white shadow-2xl`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-start justify-between gap-3 border-b border-slate-100 px-5 py-4">
          <div className="flex items-start gap-3">
            {icon && (
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-accent/10 text-brand-accent">
                {icon}
              </div>
            )}
            <div>
              <h2 className="text-base font-semibold text-slate-800">{title}</h2>
              {subtitle && <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p>}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
          >
            <X size={18} />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">{children}</div>
      </div>
    </div>
  );
}
